import { useContext } from "react";

import { Link } from "react-router-dom";

import { LinkContainer } from "react-router-bootstrap";

import Container from "react-bootstrap/Container";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import Image from "react-bootstrap/Image";
import NavDropdown from "react-bootstrap/NavDropdown";
import Col from "react-bootstrap/Col";

import logo from "assets/images/logo.png";
import logoWhite from "assets/images/logo_white.png";

import { useWindowSize } from "@evos/hooks";
import { AuthContext } from "lib/context/auth";

import {
  BsGear,
  BsList,
  BsBoxArrowLeft,
} from "react-icons/bs";

import { CloudPlatform1 as CloudIcon } from "@evos/evos-react-icons";

import "./header.css";

function useAuth() {
  return useContext(AuthContext);
}

export default function Header() {
  const auth = useAuth()!;
  const darkMode = auth?.darkMode ?? false;
  const windowWidth = useWindowSize().width ?? window.innerWidth;
  const isMobile = windowWidth < 768;
  const displayName = auth?.user?.given_name;

  const activeNavLinkStyle = (path: string) => {
    if (
      location.pathname.includes(path)
      || (location.pathname === "/" && path === "hardware-dashboard")
    ) {
      return {
        borderBottom: "5px solid #001DD2",
        borderTop: "5px solid transparent",
        color: darkMode ? "white" : "black"
      };
    } else {
      return {
        borderTop: "5px solid transparent",
        borderBottom: "5px solid transparent"
      };
    }
  };

  return (
    <Navbar bg={darkMode ? "dark" : "white"} variant={darkMode ? "dark" : "light"} sticky="top" className=" py-0" style={{boxShadow: "1px 1px 7px -4px #737373"}}>
      <Container fluid>
        <Navbar.Brand className="responsive-navbar-logo py-2 d-flex align-items-center">
          <Link to="/"><Image src={darkMode ? logoWhite : logo} height="30" className="d-inline-block align-top" /></Link>
          <div
            className="text-center fw-semibold ms-3" 
            style={{color: "#3E66FB", backgroundColor: darkMode ? "#F5F9FF" : "#ECF0FF", borderRadius: "4px", padding: "1px 6px", border: "1px solid #3E66FB", fontSize: "0.8em", marginTop: "3px"}}
          >
            ADMIN
          </div>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="evos-navbar" />
        <Navbar.Collapse id="evos-navbar" className="justify-content-end">
          { !isMobile
            && <Nav className="me-auto fw-semibold">
              <LinkContainer to="/hardware-dashboard" className="py-3" style={activeNavLinkStyle("hardware-dashboard")}>
                <Nav.Link>Hardware Monitoring</Nav.Link>
              </LinkContainer>
              <LinkContainer to="/config-manager" className="py-3" style={activeNavLinkStyle("config-manager")}>
                <Nav.Link>Config Manager</Nav.Link>
              </LinkContainer>
              <LinkContainer to="/user-list" className="py-3" style={activeNavLinkStyle("user-list")}>
                <Nav.Link>Users</Nav.Link>
              </LinkContainer>
              <LinkContainer to="/site-manager" className="py-3" style={activeNavLinkStyle("site-manager")}>
                <Nav.Link>Site Manager</Nav.Link>
              </LinkContainer>
            </Nav>
          }
          <Nav className="ms-auto d-flex align-items-center py-2 py-md-0 fw-semibold">
            <NavDropdown 
              className={ !isMobile ? "user-dropdown mb-0" : "mobile-dropdown d-inline-flex align-items-center" }
              style={{fontWeight: 500}}
              align="end" 
              title={
                !isMobile
                  ? <>
                    {displayName ?? "User"}
                    <div 
                      className="fw-semibold rounded-circle text-primary text-center d-inline-flex align-items-center justify-content-center ms-2 me-1" 
                      style={{width: "37px", height: "37px", border: "none", backgroundColor: "#ECF0FF"}}
                    >
                      <CloudIcon width="100%" />
                    </div> 
                  </>
                  : <BsList size={35} className="mb-0" style={{marginTop: "4px"}} />
              } 
            >
              { isMobile
                && <>
                  <LinkContainer to="/hardware-dashboard">
                    <NavDropdown.Item className="py-2">Hardware Monitoring</NavDropdown.Item>
                  </LinkContainer>
                  <LinkContainer to="/config-manager">
                    <NavDropdown.Item className="py-2">Config Manager</NavDropdown.Item>
                  </LinkContainer>
                  <LinkContainer to="/user-list">
                    <NavDropdown.Item className="py-2">Users</NavDropdown.Item>
                  </LinkContainer>
                  <LinkContainer to="/site-manager">
                    <NavDropdown.Item className="py-2">Site Manager</NavDropdown.Item>
                  </LinkContainer>
                </>
              }
              <LinkContainer to="/settings">
                <NavDropdown.Item className="py-2"><BsGear /> App Settings</NavDropdown.Item>
              </LinkContainer>
              <NavDropdown.Item className="py-2" onClick={() => {
                auth?.signout(() => {
                  window.localStorage.removeItem("redirectUrl");
                });
              }}>
                <BsBoxArrowLeft className="me-1" /> Logout
              </NavDropdown.Item>
              { isMobile && 
                <>
                  <NavDropdown.Divider />
                  <div className="d-flex align-items-center fw-semibold mx-2 mx-sm-3">
                    <Col 
                      xs={3}
                      className="rounded-circle text-primary text-center d-inline-flex align-items-center justify-content-center me-2" 
                      style={{width: "37px", height: "37px", border: "none", backgroundColor: "#ECF0FF"}}
                    >
                      <CloudIcon width="100%" />
                    </Col> 
                    <Col xs={9}>
                      { (displayName != null) 
                        ? (displayName.split(" ")[0].length < 20 ? displayName : displayName.split(" ")[0] + "... " + displayName.split(" ")[1])
                        : "User"
                      }
                    </Col>
                  </div>
                </>
              }
            </NavDropdown>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}
